'use client';

import Box from '@mui/material/Box';
import { Theme, SxProps } from '@mui/material/styles';

interface FullWidthContainerProps {
	children: React.ReactNode;
	beforeSx?: SxProps<Theme>;
	bgColor?: string;
}

const FullWidthContainer = ({ children, beforeSx, bgColor = 'lightBackground.main' }: FullWidthContainerProps) => {
	return (
		<Box
			sx={(theme) => ({
				position: 'relative',
				'&::before': {
					content: '""',
					position: 'absolute',
					left: 0,
					right: 0,
					top: 0,
					bottom: 0,
					backgroundColor: bgColor,
					width: '100vw',
					marginLeft: 'calc(-50vw + 50%)',
					zIndex: -1,
					...(typeof beforeSx === 'function' ? beforeSx(theme) : beforeSx),
				},
			})}
		>
			{children}
		</Box>
	);
};

export default FullWidthContainer;
